export const Constants = Object.freeze({
  LOGIN_USER: "loginUser",
  API_TOKEN: "apiToken",
  TOUR_FORM: "tourForm",
  TOUR_FORM_EDIT: "tourFormEdit",
  TOUR_FORM_STEP: "tourFormStep",
  TOUR_FORM_EDIT_STEP: "tourFormEditStep",
});
